import type { ReactNode } from "react";

interface MobileInstrumentDrawerProps {
  title: string;
  children: ReactNode;
}

export function MobileInstrumentDrawer({ title, children }: MobileInstrumentDrawerProps) {
  return (
    <details className="mobile-control-drawer mobile-instrument-drawer" data-testid="mobile-sound-drawer">
      <summary>{title}</summary>
      <div className="mobile-control-drawer-content">{children}</div>
    </details>
  );
}
